import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Icon, InfiniteTable, DLMenu } from 'appSrc/components/UI';
import EditAdvertiserModal from '../../Modals/Advertiser/EditAdvertiserModal';
import style from './styles/style.module.css';

class AllAdvertisersTable extends PureComponent {
    constructor( props ) {
        super( props );
        this.state = {
            advertiserInEdit: null,
            affiliateInEdit: null,
        };
    }

    render() {
        const { affiliates } = this.props;

        return (
            <div>
                <InfiniteTable
                loadMore={ this.props.loadMore }
                elementHeight={ 70 }>
                    { this.arrayTableRows( affiliates ) }
                </InfiniteTable>
                { this.state.advertiserInEdit &&
                    <EditAdvertiserModal closeModal={ this.onEditClose }
                    onSubmit={ this.onEditSubmit }
                    advertiser={ this.state.advertiserInEdit }
                    affiliateType={ this.state.affiliateInEdit.affiliateType } />
                }
            </div>
        );
    }

    openEditModal = ( affiliateIndex, advertiserIndex = null ) => {
        let affiliate = this.props.affiliates[ affiliateIndex ];
        let advertiser = ( advertiserIndex !== null ) ? affiliate.advertisers[ advertiserIndex ] : null;
        this.setState( { advertiserInEdit: advertiser, affiliateInEdit: affiliate } );
    }
    onEditSubmit = () => {
        this.props.onAdvertiserUpdated();
        this.setState( { advertiserInEdit: null, affiliateInEdit: null } );
    }
    onEditClose = () => {
        this.setState( { advertiserInEdit: null, affiliateInEdit: null } );
    }
    sortIcon = ( value ) => {
        const currentSort = this.props.currentSort;
        if( currentSort == value ) {
            return (
                <Icon source='fontAwesome'
                icon='fas/faSortUp'
                style={ { cursor: 'pointer' } }
                onClick={ () => { this.props.onColumnSort( value ); } } />
            );
        }
        if( currentSort == `-${ value }` ) {
            return (
                <Icon source='fontAwesome'
                icon='fas/faSortDown'
                style={ { cursor: 'pointer' } }
                onClick={ () => { this.props.onColumnSort( value ); } } />
            );
        }
        return (
            <Icon source='fontAwesome'
            icon='fas/faSort'
            style={ { cursor: 'pointer' } }
            onClick={ () => { this.props.onColumnSort( value ); } } />
        );
    };

    formatTableRow = ( data, affiliateIndex, advertiserIndex = null ) => {
        return (
            <InfiniteTable.Row key={ data.rowKey } className='dl-table-body'>
                <InfiniteTable.Cell>
                    { data.affiliateType }
                </InfiniteTable.Cell>
                <InfiniteTable.Cell>
                    { data.advertiserName }
                </InfiniteTable.Cell>
                <InfiniteTable.Cell>
                    { data.advertiserDomains &&
                        <span>
                            { data.advertiserDomains.map( ( domain ) => {
                                return (
                                    <div key={ domain.domain }>{ domain.domain }</div>
                                );
                            } ) }
                        </span>
                    }
                </InfiniteTable.Cell>
                <InfiniteTable.Cell className={ style.actionsCell }>
                    { advertiserIndex !== null && (
                        <DLMenu
                        icon={ ( <Icon source='fontAwesome' className='dropdown' icon='fas/faEllipsisH' style={ { color: '#6461ec' } } faSize='2x' /> ) }
                        direction='left' >
                            <DLMenu.Item text='Edit'
                            onClick={ () => {
                                this.openEditModal( affiliateIndex, advertiserIndex );
                            } }/>
                        </DLMenu>
                    ) }
                </InfiniteTable.Cell>
            </InfiniteTable.Row>
        );
    }

    arrayTableRows = ( affiliates ) => {
        let rows = [];
        // for each affiliate, output rows for its advertisers
        affiliates.forEach( ( affiliate, affiliateIndex ) => {
            let newRows = affiliate.advertisers.map( ( advertiser, advertiserIndex ) => {
                return this.formatTableRow( {
                    rowKey: `${affiliate.affiliateType}-${advertiser.advertiserid}`,
                    advertiserName: advertiser.advertiser_name,
                    advertiserDomains: advertiser.advertisers_domains,
                    affiliateType: affiliate.affiliateType,
                }, affiliateIndex, advertiserIndex );
            } );
            rows = rows.concat( newRows );

            // add a row for affiliates that lack separate advertisers
            if ( affiliate.advertisers.length === 0 ) {
                rows.push( this.formatTableRow( {
                    rowKey: affiliate.affiliateType,
                    advertiserName: '',
                    advertiserDomains: [],
                    affiliateType: affiliate.affiliateType,
                }, affiliateIndex ) );
            }
        } );

        rows.unshift( (
            <InfiniteTable.Row key='-1' className='dl-table-head'>
                <InfiniteTable.Cell>
                    AFFILIATE<br />TYPE { this.sortIcon( 'affiliateType,advertisers.advertiser_name' ) }
                </InfiniteTable.Cell>
                <InfiniteTable.Cell>
                    ADVERTISER<br />NAME
                </InfiniteTable.Cell>
                <InfiniteTable.Cell>
                    ADVERTISER<br />DOMAINS
                </InfiniteTable.Cell>
                <InfiniteTable.Cell>ACTIONS</InfiniteTable.Cell>
            </InfiniteTable.Row>
        ) );

        return rows;
    }
}
AllAdvertisersTable.defaultProps = {};

export default connect( null )( AllAdvertisersTable );
